/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import {saveAs} from 'file-saver'
import SearchCustomer from '../BaseComponent/SearchCustomer'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import Loader from '../loaders/loader'

class RFML extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      userCode: '',
      loading: false
    }
  }
  componentDidMount() {}

  getSingleCustomerCode = (userCode) => {
    this.setState({
      userCode
    })
  }

  submit(e) {
    e.preventDefault()
  }

  getPDF() {
    let userCode = this.state.userCode
    JASPERREPORT(`report/jasper/rfml/report?userCode=${userCode}`)
  }

  render() {
    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>توزیع</li>
            <li>گزارش سابقه خرید مشتریان</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش سابقه خرید مشتریان</p>
            </div>
            <SearchCustomer
              label={'کد کاربر'}
              getSingleCustomerCode={this.getSingleCustomerCode}
              singleResult={true}
              searchLabel={'جست و جوی مشتری'}
            />
            <div className="formComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getPDF.bind(this)}>
                گزارش سابقه خرید مشتریان
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default RFML
